"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var font_1 = require("./font");
var grey = [
    '#000',
    '#1F2D3D',
    '#273444',
    '#3C4858',
    '#8492A6',
    '#C0CCDA',
    '#D3DCE6',
    '#E0E6ED',
    '#E5E9F2',
    '#EFF2F7',
    '#F9FAFC',
    '#FFF',
];
var color = [
    '#FFC312',
    '#F79F1F',
    '#EE5A24',
    '#EA2027',
    '#C4E538',
    '#A3CB38',
    '#009432',
    '#006266',
    '#12CBC4',
    '#1289A7',
    '#0652DD',
    '#1B1464',
    '#FDA7DF',
    '#D980FA',
    '#9980FA',
    '#ED4C67',
    '#ED4C67',
    '#B53471',
    '#833471',
    '#6F1E51',
];
var color1 = ['#29EB7F', '#13CE66', '#0F9F4F'];
var color2 = ['#85D7FF', '#1FB6FF', '#009EEB'];
var color3 = ['#A389F4', '#7E5BEF', '#592DEA'];
var color4 = ['#FF7CE5', '#FF49DB', '#FF16D1'];
var color5 = ['#FF9E7C', '#FF7849', '#FF5216'];
var color6 = ['#FFD55F', '#FFC82C', '#F8B700'];
var createTheme = function (grey) {
    return {
        color: color,
        color1: color1,
        color2: color2,
        color3: color3,
        color4: color4,
        color5: color5,
        color6: color6,
        grey: grey,
        black: grey[1],
        steel: grey[2],
        slate: grey[3],
        silver: grey[4],
        smoke: [grey[7], grey[6], grey[5]],
        snow: [grey[10], grey[9], grey[8]],
        blue: '#1FB6FF',
        positive: '#13CE66',
        negative: '#FF4949',
        warning: '#FFC82C',
        space: [0, 4, 8, 16, 24, 32, 64, 128, 256, 512],
        font: font_1.font,
        fontSize: [12, 14, 16, 20, 24, 32, 48, 64, 96, 128],
    };
};
exports.theme = createTheme(grey);
exports.inverted = createTheme(grey.slice().reverse());
//# sourceMappingURL=theme.js.map